import { setDimensionType } from "store/features/bulkResize/actions";
import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { useAppDispatch, useAppSelector } from "store/store";
import { Dimension } from "store/types/resizeSettings";

export const useBulkResizerDimensionTypes = () => {
    const {
        resizeSettings: { dimensionType },
    } = useAppSelector(bulkResizeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleClick = (dimensionType: Dimension) => {
        dispatch(setDimensionType(dimensionType));
    };

    return { handleClick, dimensionType };
};

const equalityFn = (left: BulkResizeState, right: BulkResizeState) => {
    if (left.resizeSettings.dimensionType !== right.resizeSettings.dimensionType) return false;

    return true;
};
